module.exports = __webpack_public_path__ + "img/mr3.99e20554.png";